module.exports = __webpack_public_path__ + "img/produto-sem-imagem.546d22ba.jpg";